import { Stack, Typography, Switch } from "@financeable-com-au/financeable-ui";
import { useLenderCardContext } from "@/providers/LenderCardContextProvider";
import { InArrears } from "@/store/slices/types/applicationFormSlice";

const DefaultRepayments = () => {
  const {
    product,
    lenderCard: { repayments, fees },
    inArrears,
    setInArrears,
  } = useLenderCardContext();
  const { lender, productName } = product ?? {};

  return (
    <>
      <Stack flexDirection="row" columnGap={1} alignItems="center">
        <Typography level="body-md" bold component="h3" textColor="neutral.900">
          {lender}
        </Typography>
        <Typography level="body-sm">({productName})</Typography>
      </Stack>
      <Stack>
        {repayments.monthlyRange ? (
          <Typography level="title-sm" component="h4">
            {repayments.monthlyRange.min.formattedValue} - {repayments.monthlyRange.max.formattedValue}
          </Typography>
        ) : (
          <Typography level="title-md" component="h4">
            {repayments.monthly.formattedValue}
          </Typography>
        )}
        {repayments.weeklyRange ? (
          <Typography level="body-sm">
            ({repayments.weeklyRange.min.formattedValue} - {repayments.weeklyRange.max.formattedValue})
          </Typography>
        ) : (
          <Typography level="body-sm">({repayments.weekly.formattedValue})</Typography>
        )}
      </Stack>
      <Stack flexDirection="row" alignItems="center" columnGap={1}>
        <Typography level="body-xs" textColor={inArrears === InArrears.No ? "primary.200" : "neutral.900"}>
          In advance
        </Typography>
        <Switch
          size="sm"
          variant="outlined"
          checked={inArrears === InArrears.Yes}
          onChange={(event) => setInArrears(event.target.checked ? InArrears.Yes : InArrears.No)}
          slotProps={{ input: { "aria-label": "Repayment timing" } }}
        />
        <Typography level="body-xs" textColor={inArrears === InArrears.Yes ? "primary.200" : "neutral.900"}>
          In arrears
        </Typography>
      </Stack>
      {fees.totalMonthly.formattedValue && (
        <Typography level="body-xs" textColor="neutral.500">
          Includes {fees.totalMonthly.formattedValue} monthly fees
        </Typography>
      )}
    </>
  );
};

export { DefaultRepayments };
